<template>
    <div>
        <b-card-header>
            <b-nav card-header tabs>
                <b-nav-item :to="{name: 'projects.show', params: {projectId}}" exact>
                    {{ $t('Overview') }}
                </b-nav-item>

                <b-nav-item
                    v-if="$gate.allow('viewAny', 'element')"
                    :to="{name: 'projects.elements', params: {projectId}}"
                >
                    {{ $t('Elements') }}
                </b-nav-item>

                <b-nav-item
                    v-if="$gate.allow('viewAny', 'service')"
                    :to="{name: 'projects.services', params: {projectId}}"
                >
                    {{ $t('Services') }}
                </b-nav-item>

                <b-nav-item
                    v-if="$gate.allow('viewAny', 'foundation')"
                    :to="{name: 'projects.foundations', params: {projectId}}"
                >
                    {{ $t('Foundations') }}
                </b-nav-item>

                <b-nav-item :to="{name: 'projects.services-to-complete', params: {projectId}}">
                    {{ $t('Services to complete') }}
                </b-nav-item>
            </b-nav>
        </b-card-header>

        <router-view :project="project" />
    </div>
</template>
<script>
    export default {
        name: 'ProjectMeasurement',
        props: {
            projectId: {
                type: [Number, String],
                default: null,
            },
            project: {
                type: Object,
                default: null,
            },
        },
    }
</script>
